<template>
<div>
  <main-header-nav :content="'首页'"></main-header-nav>
  <div>
    <img src="../../assets/home/homeBg.jpg" style="position: absolute;width: calc(100% - 250px);height: calc(100% - 100px);margin-top: -36px;">
    <div style="position: absolute;left: calc(50% - 189px);top: 220px;">
      <img src="../../assets/home/title.png"/>
    </div>
    <div style="position: absolute;left: calc(50% - 315px);bottom: 310px;">
      <a href="#" v-on:click="goto('my_projects')">
        <img src="../../assets/home/1.png"/>
      </a>
    </div>
    <div  style="position: absolute;left: calc(50% - 175px);bottom: 120px;">
      <a href="#" v-on:click="goto('total_projects_model')">
        <img src="../../assets/home/2.png"/>
      </a>
    </div>
    <div style="position: absolute;left: calc(50% + 35px);bottom: 50px;">
      <a href="#" v-on:click="goto('add_project_cost_estimate')">
        <img src="../../assets/home/3.png"/>
      </a>
    </div>
    <div style="position: absolute;left: calc(50% + 257px);bottom: 120px;">
      <a href="#" v-on:click="goto('major_materials')">
        <img src="../../assets/home/4.png"/>
      </a>
    </div>
    <div style="position: absolute;left: calc(50% + 390px);bottom: 310px;">
      <a href="#" v-on:click="goto('total_project_files')">
        <img src="../../assets/home/5.png"/>
      </a>
    </div>
  </div>
</div>
</template>

<script>
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'AppIndex',

  components: {
    MainHeaderNav
  },

  methods: {
    goto (path) {
      this.$router.push(path)
    }
  }
}
</script>
<style>
.bg-container {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url('../../assets/home/homeBg.jpg');
}
</style>
